import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-number-input";
import { Form, Row, Col } from "react-bootstrap";

import "./AdoptionForm.css";

const AdoptionForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    area: "",
    pan: "",
    pin: "",
    cv: "",
  });

  const adoption = JSON.parse(localStorage.getItem("Adoption"));
  const [change, setChange] = useState(false);
  const [donationError, setDonationError] = useState({});
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cv, setCv] = useState();
  const [ext, setExt] = useState("");

  useEffect(() => {
    if (adoption) {
      setFormData(adoption);
    }
  }, []);

  const formHandler = (e) => {
    e.preventDefault();
    if (e.target.name === "other") {
      const div = document.getElementsByClassName("amt");
      for (var i = 0; i < div.length; i++) {
        div[i].checked = false;
      }
    } else if (e.target.name === "amount") {
      document.getElementsByName("other")[0].value = "";
    } else {
      if (e.target.name === "cv") {
        var value = e.target.files[0];
        console.log(value);
      } else {
        var value = e.target.value;
      }
      setFormData({ ...formData, [e.target.name]: value });
    }
    console.log(formData);
  };

  if (formData) {
    localStorage.setItem("Adoption", JSON.stringify(formData));
  }

  const phoneHandler = (e) => {
    // e.preventDefault();
    setFormData({ ...formData, phone: e });
    console.log(formData);
  };

  async function submitDonateForm(e) {
    e.preventDefault();
    var form = document.getElementById("donateForm");
    form.classList.add("was-validated");
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    } else if (formData.phone.length <= 3) {
      e.stopPropagation();
    } else {
      setLoading(true);
      var resData = "";
      var adopt = document.getElementById("adopt-submit").innerText;
      var url = "https://api.postalpincode.in/pincode/" + formData.pin;
      await fetch(url, {
        method: "GET",
      })
        .then((res) => res.json())
        .then(async (res) => {
          resData = await res;
        })
        .catch((err) => console.log(err));

      let number;
      number =
        formData.phone.substring(0, 3) +
        " " +
        formData.phone.substring(3, 8) +
        " " +
        formData.phone.substring(8, formData.phone.length);
      const body = {
        purpose: formData.purpose,
        name: formData.name,
        phone: number,
        email: formData.email,
        pan: formData.pan ? formData.pan : "",
        pin: formData.pin,
        area: formData.area,
        cv: formData.cv,
        adopt: adopt,
        state: resData[0].PostOffice[0].State,
        region: resData[0].PostOffice[0].Region,
        postalName: resData[0].PostOffice[0].Name,
        ext: ext,
      };
      console.log(JSON.stringify(body));

      var cv_url;
      console.log(cv);
      const data = new FormData();
      data.append("file", cv);
      data.append("upload_preset", process.env.REACT_APP_CLOUDINARYPRESET);
      data.append("cloud_name", process.env.REACT_APP_CLOUDINARYNAME);
      await fetch(
        `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARYNAME}/auto/upload`,
        {
          method: "post",
          body: data,
        }
      )
        .then((resp) => resp.json())
        .then((data) => {
          cv_url = data.url;
        })
        .catch((e) => {
          console.log(e);
        });
      body.cv_url = cv_url;
      console.log(body);
      await fetch(
        "https://5qahboc8gj.execute-api.ap-south-1.amazonaws.com/production/adoption",
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
          },
          body: JSON.stringify(body),
        }
      )
        .then(async (res) => {
          const resData = await res;
          console.log(resData);
          setFormData({
            name: "",
            phone: "",
            email: "",
            area: "",
            pan: "",
            pin: "",
            cv: "",
          });
          localStorage.removeItem("Adoption");
          setLoading(false);
          setSuccess(true);
        })
        .catch((err) => console.log(err));
    }
  }

  const changeFile = (e) => {
    setCv(e.target.files[0]);
    const extension = e.target.files[0].name.split(".").pop();
    setExt(extension);
  };

  return (
    <>
      <div className="form-wrapper">
        <div className="form-container scrollbar-hide form-container-adoption">
          <Form
            onSubmit={(e) => submitDonateForm(e)}
            className="w-100 needs-validation"
            id="donateForm"
            noValidate
          >
            <Row className="mb-2">
              <Form.Group as={Col}>
                <Form.Control
                  type="text"
                  value={formData?.name && formData?.name}
                  name="name"
                  placeholder="Name*"
                  onChange={(e) => formHandler(e)}
                  required
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group>
                <PhoneInput
                  placeholder="00000 000000"
                  id="phone-input"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => phoneHandler(e)}
                  international
                  defaultCountry="IN"
                  countryCallingCodeEditable={false}
                  required
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col}>
                <Form.Control
                  type="email"
                  value={formData?.email && formData?.email}
                  name="email"
                  placeholder="Email*"
                  onChange={(e) => formHandler(e)}
                  required
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col}>
                <Form.Control
                  type="text"
                  value={formData?.pan && formData?.pan}
                  name="pan"
                  placeholder="PAN"
                  onChange={(e) => formHandler(e)}
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col}>
                <Form.Control
                  type="text"
                  value={formData?.pin && formData?.pin}
                  name="pin"
                  placeholder="Pincode*"
                  onChange={(e) => formHandler(e)}
                  required
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col}>
                <Form.Control
                  type="number"
                  // value={formData?.name && formData?.name}
                  name="area"
                  placeholder="Area available per cow (sq feet)"
                  onChange={(e) => formHandler(e)}
                  required
                />
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col}>
                <Form.Control
                  type="file"
                  id="volunteerCV"
                  name="cv"
                  onChange={(e) => changeFile(e)}
                  required
                />
              </Form.Group>
            </Row>
            <div className="row mx-0 mt-2 mb-2 d-flex justify-content-center">
              <button className="btn submitFormBtn" id="adopt-submit">
                Adopt
              </button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default AdoptionForm;
